import { noop } from 'lodash-es';

import type { ITagManager } from './gtmInterface';

export const gtmMockInterface = async (): Promise<ITagManager> => ({ initialize: noop, push: noop });
